module.exports = __webpack_public_path__ + "fonts/nunito-sans-400-italic-latin.17afe7f.woff2";